import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@rocco/components/accordion';
import { SortOption } from '@rocco/types/enum/sort-option';
import { useState } from 'react';

interface FiltersModalSortProps {
    sort?: SortOption;
    onSortChange: (sort: SortOption) => void;
}

export const FiltersModalSort = (props: FiltersModalSortProps) => {
    const { sort = SortOption.Featured, onSortChange } = props;
    const { sortOptions } = useFiltersContext();

    const [isOpen, setIsOpen] = useState(true);

    return sortOptions.length > 0 ? (
        <div className="flex flex-col gap-2">
            <Accordion
                type="single"
                collapsible={true}
                defaultValue="sort-by"
                onValueChange={() => setIsOpen(!isOpen)}
            >
                <AccordionItem value="sort-by">
                    <div className="px-6 md:px-0">
                        <AccordionTrigger
                            variant="spacious"
                            icon="plus"
                            openIcon="minus"
                            isOpen={isOpen}
                        >
                            <div className="flex w-full items-center justify-between">
                                <span>Sort By</span>
                            </div>
                        </AccordionTrigger>
                        <AccordionContent>
                            <div className="grid pb-2 pt-2">
                                {sortOptions.map((sortOption) => (
                                    <div
                                        key={sortOption.value}
                                        className="flex flex-row-reverse items-center justify-between pl-0"
                                    >
                                        <RoccoCheckbox
                                            id={sortOption.value}
                                            checked={sort === sortOption.value}
                                            shape="round"
                                            onCheckedChange={(checked) =>
                                                checked &&
                                                onSortChange(sortOption.value)
                                            }
                                        />
                                        <RoccoLabel
                                            htmlFor={sortOption.value}
                                            target="checkboxReversed"
                                        >
                                            {sortOption.title}
                                        </RoccoLabel>
                                    </div>
                                ))}
                            </div>
                        </AccordionContent>
                    </div>
                </AccordionItem>
            </Accordion>
        </div>
    ) : null;
};
